import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/request-reset`, { email });
      setSent(true);
    } catch (error) {
      console.error('Reset request failed:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: 'var(--navy-50)' }}>
      <div className="max-w-md w-full bg-white p-8 rounded-lg border border-gray-200 shadow-sm">
        {sent ? (
          <div className="text-center space-y-4">
            <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Manrope', color: 'var(--navy-900)' }}>
              Check your email
            </h1>
            <p className="text-gray-600">
              If an account exists for <span className="font-medium">{email}</span>, a reset
              link is on its way. The link works for one hour.
            </p>
            <p className="text-gray-600 text-sm">
              Nothing in your inbox after a few minutes? Check your spam folder, or try again
              with a different address.
            </p>
            <div className="pt-2 space-y-2">
              <button
                onClick={() => setSent(false)}
                className="text-sm block w-full"
                style={{ color: 'var(--navy-600)' }}
              >
                Use a different email
              </button>
              <button
                onClick={() => navigate('/login')}
                className="text-sm text-gray-600 hover:text-navy-900 transition-colors duration-200"
              >
                ← Back to sign in
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Manrope', color: 'var(--navy-900)' }}>
                Reset your password
              </h1>
              <p className="text-gray-600">
                Enter the email you signed up with and we'll send you a reset link.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: 'var(--navy-900)' }}>
                  Email
                </label>
                <Input
                  data-testid="forgot-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="w-full"
                />
              </div>

              <Button
                type="submit"
                data-testid="forgot-submit-btn"
                disabled={loading}
                className="w-full py-6 text-base font-medium rounded-lg transition-colors duration-200"
                style={{ backgroundColor: 'var(--navy-900)', color: 'white' }}
              >
                {loading ? 'Please wait...' : 'Send reset link'}
              </Button>

              <div className="text-center">
                <button
                  type="button"
                  onClick={() => navigate('/login')}
                  className="text-sm text-gray-600 hover:text-navy-900 transition-colors duration-200"
                >
                  ← Back to sign in
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
